import * as moment from "moment";
var monthList = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec",
];
export var leadLogsMapper = function (data) {
    var result = [];
    if (data && data.length > 0) {
        var groups_1 = data.reduce(function (groups, log) {
            var date = !!log.logDate
                ? moment(log.logDate, "YYYY-MM-DD HH:mm:ss").format("MMM YYYY")
                : "";
            if (date) {
                if (!groups[date]) {
                    groups[date] = [];
                }
                groups[date].push(log);
            }
            return groups;
        }, {});
        result = Object.keys(groups_1).map(function (date) {
            return {
                title: date,
                logs: groups_1[date],
            };
        });
    }
    return result.length > 0 ? sortByMonth(result) : result;
};
function sortByMonth(groupArrays) {
    return groupArrays.sort(function (a, b) {
        var x = a.title.split(" ");
        var y = b.title.split(" ");
        if (x[1] !== y[1]) {
            return y[1] - x[1];
        }
        else {
            return monthList.indexOf(y[0]) - monthList.indexOf(x[0]);
        }
    });
}
